import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import {LocalStorageService} from '../../services/local-storage.service';
import {UserService} from '../../services/user/user.service';
import {AuthService} from '../../services/auth.service';
import {LanguageService} from '../../services/language.service';

/**
 * @deprecated The component should not be used
 */
@Component({
  selector: 'app-login-modal',
  styleUrls: ['./login-modal.component.scss'],
  templateUrl: './login-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LoginModalComponent implements OnInit {

  @Input() type: string;

  public loginForm: any = {}; // TODO create object instead of any
  public signUpForm: any = {}; // TODO create object instead of any
  public isLoggedIn = false;
  public isLoginFailed = false;
  public isSignUpSuccess = false;
  public isSignUpFailed = false;
  public errorMessage = '';

  currentUser: any = {}; // TODO create object instead of any

  redirectUri = `?redirect_uri=${environment.frontendUrl}/home/login`;

  constructor(private activeModal: NgbActiveModal,
              private activatedRoute: ActivatedRoute,
              private localStorageService: LocalStorageService,
              private userService: UserService,
              private authService: AuthService,
              public languageService: LanguageService) {}

  public ngOnInit(): void {

    const token: string = this.activatedRoute.snapshot.queryParamMap.get('token');
    const error: string = this.activatedRoute.snapshot.queryParamMap.get('error');

    if (this.localStorageService.getToken()) {
      this.isLoggedIn = true;
      this.currentUser = this.localStorageService.getUser();
      this.activeModal.close();
    } else if (token) {
      this.localStorageService.saveToken(token);
      this.userService.getCurrentUser().subscribe({
        next: (user) => {
          this.login(user);
        },
        error: (err) => {
          this.errorMessage = err.error.message;
          this.isLoginFailed = true;
        }
      });
    } else if (error) {
      this.errorMessage = error;
      this.isLoginFailed = true;
    }
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }

  public login(user): void {
    this.activeModal.close();
    this.localStorageService.saveUser(user);
    this.isLoginFailed = false;
    this.isLoggedIn = true;
    this.currentUser = user;
    this.languageService.switchLanguageByEnum(user.language);
    window.location.href = `${environment.frontendUrl}`;
  }

  onSignUpSubmit(): void {
    this.authService.register(this.signUpForm, this.languageService.getEnumValueByCurrentLang()).subscribe({
      next: () => {
        this.activeModal.close();
        this.isSignUpSuccess = true;
        this.isSignUpFailed = false;
      },
      error: (data) => {
        this.errorMessage = data.error.message;
        this.isSignUpFailed = true;
      },
    });
  }

  onLoginSubmit(): void {

    this.authService.login(this.loginForm).subscribe({
      next: (data) => {
        if (data.user.roles.length === 1 && data.user.roles.includes('ROLE_USER')) {
          this.errorMessage = 'Access denied';
          this.isLoginFailed = true;
          return;
        }
        this.localStorageService.saveToken(data.accessToken);
        this.login(data.user);
      },
      error: (data) => {
        this.errorMessage = data.status + ' ' + data.error.message;
        this.isLoginFailed = true;
      },
    });
  }

  googleLogin(): void {
    window.location.href = `${environment.backendBaseUrl}/oauth2/authorization/google` + this.redirectUri;
  }

  facebookLogin(): void {
    window.location.href = `${environment.backendBaseUrl}/oauth2/authorization/facebook` + this.redirectUri;
  }
}
